<table>
  <thead>
    <tr>
      <th class="reference-column">Document reference</th>
      <th class="title-column">Document title</th>
      <th class="version-column" *ngIf="direction === ReferenceSummaryType.OUTGOING">Target version</th>
      <th class="reference-count-column last-published" *ngIf="direction !== ReferenceSummaryType.SAME_DOCUMENT">
        Number of invalid references<br />(last published)
      </th>
      <th class="reference-count-column live">Number of invalid references<br />(live)</th>
      <th class="publication-status" [class.narrow]="direction !== ReferenceSummaryType.INCOMING">
        Publication status
      </th>
      <th *ngIf="direction !== ReferenceSummaryType.INCOMING" class="dropdown-column"></th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let row of referenceRows">
      <tr>
        <td>{{ row.documentCode }}</td>
        <td>
          <a [href]="generateLinkToDocument(row)" target="_blank">{{ row.documentTitle }}</a>
        </td>
        <td *ngIf="direction === ReferenceSummaryType.OUTGOING">
          <div class="flex-div">
            <div class="version-toggle no-print" *ngIf="CarsAction.AUTHOR_DOCUMENT | carsEnabled : documentId | async">
              <mat-slide-toggle
                color="primary"
                (change)="toggleTargetVersion(row)"
                [checked]="row.targetVersionIsLive"
                class="flex-icon"
              >
              </mat-slide-toggle>
            </div>
            <span>{{ row.targetVersionIsLive ? 'Live document' : 'Last published' }}</span>
          </div>
        </td>
        <td *ngIf="direction !== ReferenceSummaryType.SAME_DOCUMENT">
          <ng-container *ngIf="!!row.lastPublishedVersionTag; else noVersionTagTemplate">
            <div class="flex-div" *ngIf="generateReferenceStateIcon(row, false) as stateIcon">
              <mat-icon class="flex-icon {{ stateIcon }}">{{ stateIcon }}</mat-icon>
              <span class="flex-text"
                >{{ row.lastPublishedNumberOfInvalidReferences }}/{{ row.lastPublishedNumberOfReferences }}</span
              >
            </div>
            <ng-container *ngIf="!!row.lastPublishedVersionTag">
              <a [href]="generateLinkToVersion(row)" target="_blank">{{ formatVersionNumberForDisplay(row) }}</a>
              <div>{{ row.lastPublishedVersionTag.dateOfPublication | date : 'dd/MM/yyyy' }}</div>
            </ng-container>
          </ng-container>
          <ng-template #noVersionTagTemplate>
            <span>N/A</span>
          </ng-template>
        </td>
        <td class="flex-content">
          <div class="flex-div" *ngIf="generateReferenceStateIcon(row, true) as stateIcon">
            <mat-icon class="flex-icon {{ stateIcon }}">{{ stateIcon }}</mat-icon>
            <span class="flex-text">{{ row.liveNumberOfInvalidReferences }}/{{ row.liveNumberOfReferences }}</span>
          </div>
        </td>
        <td *ngIf="generatePublicationStatusInformation(row) as statusInformation">
          <div class="flex-div">
            <mat-icon class="{{ statusInformation.icon }} flex-icon">{{ statusInformation.icon }}</mat-icon>
            <span class="flex-text">{{ statusInformation.text }}</span>
          </div>
        </td>
        <td *ngIf="direction !== ReferenceSummaryType.INCOMING" class="dropdown-column">
          <div (click)="row.rowExpanded = !row.rowExpanded" class="no-print">
            <mat-icon *ngIf="row.rowExpanded">expand_more</mat-icon>
            <mat-icon *ngIf="!row.rowExpanded">chevron_right</mat-icon>
          </div>
        </td>
      </tr>
      <tr *ngIf="row.rowExpanded" class="expanded-table-row">
        <td [attr.colspan]="direction === ReferenceSummaryType.OUTGOING ? 7 : 5">
          <cars-reference-summary-expanded-table
            [referenceSummaryRow]="row"
            [fullDocumentTree]="fullDocumentTree"
          ></cars-reference-summary-expanded-table>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
